import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import * as pdp from '../../../store/productDetailPage'

const ProductSidebarDescription = ({productDescription}) => <p>{productDescription}</p>

ProductSidebarDescription.defaultProps = {
  productDescription: 'No Description Available',
}

ProductSidebarDescription.propTypes = {
  productDescription: PropTypes.string,
}

const mapStateToProps = (state) => ({
  productDescription: pdp.productDescription(state),
})

export default connect(mapStateToProps)(ProductSidebarDescription)
